import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { instructorRanks, Person, Rank, scoutRanks } from '../types/form';
import { getInstructorRank, getScoutRank } from '../helpers/rank';

interface FormRankProps {
  person: Person;
  rank: Rank;
  setRank: (name: Rank) => void;
}

function FormRank({ person, rank, setRank }: FormRankProps) {
  return (
    <Form.Group className="mb-3" controlId="formRank">
      <Form.Label>Stopień instruktorski i harcerski:</Form.Label>
      <InputGroup>
        <Form.Select value={rank.instructor || ''} onChange={(event: any) => {
          setRank({ instructor: event.target.value || null, scout: rank.scout });
        }}>
          <option key="" value="">-</option>
          {instructorRanks.map(rank => <option key={rank} value={rank}>
            {getInstructorRank(person, rank)}
          </option>)}
        </Form.Select>
        <Form.Select value={rank.scout || ''} onChange={(event: any) => {
          setRank({ instructor: rank.instructor, scout: event.target.value || null });
        }}>
          <option key="" value="">-</option>
          {scoutRanks.map(rank => <option key={rank} value={rank}>
            {getScoutRank(person, rank, true)}
          </option>)}
        </Form.Select>
      </InputGroup>
    </Form.Group>
  );
}

export default FormRank;
